import React from 'react'
import ContactSocial from './ContactSocial';
import { Box } from '@mui/material';
import { ReactComponent as Tiktok } from './../../assets/icons/tiktok.svg'
import { ReactComponent as Snap } from './../../assets/icons/snap.svg'
import { ReactComponent as Youtube } from './../../assets/icons/youtube.svg'
import { ReactComponent as Facebook } from './../../assets/icons/facebook.svg'
import { ReactComponent as Instagram } from './../../assets/icons/instagram.svg'
import { ReactComponent as Twitter } from './../../assets/icons/twitter.svg'
import { StyledBox } from './footers/StyledBox';

const Social = ({ data }) => {
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: { md: 'nowrap', xs: 'wrap' }, justifyContent: { md: 'space-around', xs: 'center' } }}>
                {/* {data?.linkedinUrl &&
                    <ContactSocial link={data?.linkedinUrl} >
                        <StyledBox>
                            <LinkedInIcon />
                        </StyledBox>
                    </ContactSocial>
                } */}
                {data?.youtubeUrl &&
                    <ContactSocial link={data?.youtubeUrl} >
                        <StyledBox>
                            <Youtube />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.snapchatUrl &&
                    <ContactSocial link={data?.snapchatUrl}>
                        <StyledBox>
                            <Snap />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.tiktokUrl &&
                    <ContactSocial link={data?.tiktokUrl}>
                        <StyledBox>
                            <Tiktok />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.twitterUrl &&
                    <ContactSocial link={data?.twitterUrl}>
                        <StyledBox>
                            <Twitter />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.instagramUrl &&
                    <ContactSocial link={data?.instagramUrl} >
                        <StyledBox>
                            <Instagram />
                        </StyledBox>
                    </ContactSocial>
                }
                {data?.facebookUrl &&
                    <ContactSocial link={data?.facebookUrl} >
                        <StyledBox>
                            <Facebook />
                        </StyledBox>
                    </ContactSocial>
                }
            </Box>
        </>
    )
}

export default Social